// This should only be included in app.vue and nothing else
// otherwise you will see event listener duplication
export const eventListeners = {
    methods: {
        hookEvents: function () {
            document.addEventListener('eventLogout', function () {
                
            });

            document.addEventListener('eventLogin', function () {
                window.PeBL.emitEvent(window.PeBL.events.newBookNoReset, 'epub3-mgig.epub');
            });

        }
    }
};
